import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { AppThunk } from 'store'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import {
  trySimulatorExerciseSession,
  stopSimulatorExerciseSession,
} from 'modules/simulatorTrainings/instructor/studentLed/ExerciseSheet/api/exerciseSheetService'
import { ExerciseSheetState, ApiTrySimulatorExerciseSessionResponse } from './types'

const initialState: ExerciseSheetState = {
  trySimulatorExerciseSessionRequest: {},
  stopSimulatorExerciseSessionRequest: {},
}

const exerciseSheetSlice = createSlice({
  name: 'simulatorTrainingInstructorSLExerciseSheet',
  initialState,
  reducers: {
    trySimulatorExerciseSessionRequested(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiTrySimulatorExerciseSessionResponse>>
    ) {
      state.trySimulatorExerciseSessionRequest = action.payload
    },
    clearTrySimulatorExerciseSession(state) {
      state.trySimulatorExerciseSessionRequest = initialState.trySimulatorExerciseSessionRequest
    },
    stopSimulatorExerciseSessionRequested(state, action: PayloadAction<ApiMiddlewarePayload>) {
      state.stopSimulatorExerciseSessionRequest = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const {
  trySimulatorExerciseSessionRequested,
  stopSimulatorExerciseSessionRequested,
  clearTrySimulatorExerciseSession,
} = exerciseSheetSlice.actions
export { clearTrySimulatorExerciseSession }
export default exerciseSheetSlice.reducer

export const trySimulatorExerciseSessionRequest = (exerciseId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      startLink: () => trySimulatorExerciseSession(exerciseId),
    },
    payloadAction: trySimulatorExerciseSessionRequested,
    shouldShowGlobalLoading: true,
    enableErrorNotification: true,
  })
}

const handleClearTrySimulatorExercieseSession =
  (response: ApiMiddlewarePayload): AppThunk =>
  async dispatch => {
    const { error } = response
    !error && dispatch(clearTrySimulatorExerciseSession())
    dispatch(stopSimulatorExerciseSessionRequested(response))
  }

export const stopSimulatorExerciseSessionRequest = (sessionId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      request: () => stopSimulatorExerciseSession(sessionId),
    },
    payloadAction: stopSimulatorExerciseSessionRequested,
    enableErrorNotification: true,
    shouldShowGlobalLoading: true,
    nextAction: handleClearTrySimulatorExercieseSession,
  })
}
